import dayjs from 'dayjs';
import React from 'react'
import { useHistory } from 'react-router-dom';
import { IoAdd } from 'react-icons/io5';
import ShowPaginationData from '../../../components/UI/TableView/ShowPaginationData';

function ReturnSwimmingItems() {
    const currentCenterId = '66bdca9b7add38fef2918d63'

    const { columns, id, label, url, href } = {
        id: 'return-items', label: 'return-items',
        href: '/return-items',
        columns: [{ label: '#', value: a => a._id.slice(0, 10) },
        { label: 'by', classnames: () => 'font-[Montserrat]', value: (a) => a.admin?.name || 'unknown' },
        { label: 'items', value: (a) => a.items.length },
        { label: 'date', value: (a) => dayjs(a.createdAt).format('YYYY-MM-DD HH:mm') },
        ],
        url: (centerId) => `/swimming-return-items/${currentCenterId}?` + centerId,
    }
    const history = useHistory()

    const onAddStorage = () => {
        history.push(`/swimming-storage/return-items/1`)
    }
    
    return (
        <div className="flex flex-col items-center justify-center flex-1 bg-white">
            <ShowPaginationData hrefId={null} onClickItem={(data) => {
                history.push(`/swimming-storage/return-items/view/${data._id}`, {
                    data
                })
            }} rightButton={<div className="cursor-pointer" >
                <IoAdd onClick={onAddStorage} size={30} />
            </div>} columns={columns} href={href} id={id} label={label} url={url} />
        </div>
    )
}

export default ReturnSwimmingItems
